import { render, staticRenderFns } from "./DMRReport2.vue?vue&type=template&id=1bc763ad&scoped=true&"
import script from "./DMRReport2.vue?vue&type=script&lang=js&"
export * from "./DMRReport2.vue?vue&type=script&lang=js&"
import style0 from "./DMRReport2.vue?vue&type=style&index=0&id=1bc763ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc763ad",
  null
  
)

export default component.exports